module.exports = __webpack_public_path__ + "static/img/4.6f247e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/eng/4.png
// module id = OYLj
// module chunks = 0